/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSupervisorVisitResponse } from './oralExamSupervisorVisitResponse';

export type OralExamSupervisorEntryResponseVisit = OralExamSupervisorVisitResponse | null;
